/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {
    SequentiallyBetWayInitialWPController
} from "@nolimitcity/slot-game/bin/game/winpresentation/initial/sequentially/SequentiallyBetWayInitialWPController";
import {Timeline, TimelineLite} from "gsap";
import {DeadwoodGameConfig} from "../../DeadwoodGameConfig";
import {DeadwoodSoundConfig} from "../../DeadwoodSoundConfig";
import {DeadwoodReelView} from "../../reel/DeadwoodReelView";
import {DeadwoodParsedGameData} from "../../server/data/DeadwoodParsedGameData";
import {DeadwoodReelSymbol} from "../../symbols/DeadwoodReelSymbol";
import {DeadwoodStackedWild} from "../../symbols/DeadwoodStackedWild";
import {DeadwoodInitialWinCountUp} from "./DeadwoodInitialWinCountUp";
import {DeadwoodInitialWPView} from "./DeadwoodInitialWPView";
import {DeadwoodWaysWonGFXText} from "./DeadwoodWaysWonGFXText";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";

// @ts-ignore
export class DeadwoodInitialWPController extends SequentiallyBetWayInitialWPController {

    private _symbolDelay:number = 0.1;
    private _betWayDelay:number = 0.5;

    private _gameView:DeadwoodInitialWPView;
    private _winCountUp:DeadwoodInitialWinCountUp;
    private _waysWon:DeadwoodWaysWonGFXText;

    private _doReelNudge:boolean[];
    private _isTinyWin:boolean;
    private _isFastWin:boolean;
    private _winWaysWon:number = 0;
    private _bigWinLineSoundIndex:number = 0;
    private _winTextPosition:PIXI.Point;
    private _belowStakeWinRestriction:boolean;

    // @ts-ignore
    constructor(indexes:[number, number]) {
        super(indexes);

        this._gameView = new DeadwoodInitialWPView();
        this._winCountUp = new DeadwoodInitialWinCountUp();
        this._winCountUp.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.5);
        StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);

        this._waysWon = new DeadwoodWaysWonGFXText();
    }

    protected parseFeatureGameData(data:DeadwoodParsedGameData):void {
        this._doReelNudge = data.doReelNudge;
        const winType:WinRatioType = data.currentWinRatioConfig!.type!;
        this._isTinyWin = winType === WinRatioType.TINY;
        this._isFastWin = winType === WinRatioType.TINY || winType === WinRatioType.SMALL;
        (<DeadwoodInitialWinCountUp>this._winCountUp).isTinyWin = this._isTinyWin;
        this._belowStakeWinRestriction = BelowStakeWinRestriction.isWinBelowPlayedBetValue(data.totalWin, data.playedBetValue);
    }

    protected addSingleBetWinAnimationToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number):number {
        this._winTextPosition = this.getWinTextPosition(betWayWinData.reelWinPositions);
        const delay:number = super.addSingleBetWinAnimationToTimeline(betWayWinData, timeline, startTime);

        this._winWaysWon += betWayWinData.numberOfCombinations;
        if(!this._belowStakeWinRestriction) {
            const winWaysWon = this._winWaysWon;
            timeline.add(() => {
                this._waysWon.showWinWaysWon(winWaysWon, true, this._gameData!.isBigWin);
                if(this._gameData!.isBigWin) {
                    DeadwoodSoundConfig.playBigWinInitialLineSound(this._bigWinLineSoundIndex);
                    this._bigWinLineSoundIndex++;
                }
            }, startTime);
        }

        return this._isFastWin ? 0 : delay + this._betWayDelay;
    }

    private getWinTextPosition(reelWinPositions:boolean[][]):PIXI.Point {
        for(let reelId = reelWinPositions.length - 1; reelId >= 0; reelId--) {
            for(let symId = 0; symId < 3; symId++) {
                if(reelWinPositions[reelId][symId] && !Reels.getSymbol(reelId, symId)?.symName.includes("W")) {
                    return new PIXI.Point(reelId, symId);
                }
            }
        }
        return new PIXI.Point(0, reelWinPositions[0].indexOf(true));
    }

    protected addSymbolWinAnimationToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number, symbol:DeadwoodReelSymbol, reelId:number, symbolId:number):number {
        const isWild:boolean = symbol.symName.indexOf("W") > -1;
        if(isWild && symbolId != 1) {
            return 0;
        }

        if(this._belowStakeWinRestriction) {
            return 0;
        }

        timeline.add(
            symbol.changeState({
                state : GameConfig.instance.SYMBOL_STATES.win,
                setStack : true,
                fadeInDuration : 0.1,
                replay : !isWild
            }), startTime);

        (<DeadwoodReelView>Reels.getReel(reelId)!.view).addSymbolToWinContainer(symbol);
        const position:[number, number] = Helper.getSymbolPositions(reelId, symbolId);
        if(!this._isTinyWin) {
            this._gameView.addSymbolGlowToTimeline(timeline, startTime, position, isWild);
        }
        if(reelId === this._winTextPosition.x && symbolId === this._winTextPosition.y) {
            this._gameView.addWinNumberToTimeline(timeline, startTime, position, symbol, betWayWinData);
        }

        return this._isFastWin ? 0 : this._symbolDelay;
    }

    protected addWinCountUpToTimeline(timeline:Timeline):void {
        if(this._gameData!.isBigWin) {
            return;
        }

        if(this._belowStakeWinRestriction) {
            SlotGame.winFieldController.showWinField();
            return;
        }

        const duration:number = this._gameData!.currentWinRatioConfig!.duration;
        const countUpTimeline:TimelineLite = new TimelineLite();
        countUpTimeline.add(this._winCountUp.getCountUpAnimation(0, this._gameData!.singleWin, duration, this._gameData!.currentMultiplier, this._belowStakeWinRestriction));
        countUpTimeline.add(() => this._winCountUp.stay(this._belowStakeWinRestriction));  // #369
        countUpTimeline.add(() => SlotGame.winFieldController.showWinField());

        timeline.add(countUpTimeline, 0);
    }

    protected startWinPresentation():void {
        super.startWinPresentation();

        this._gameView.startWinPresentation();

        const winSound:string | null = DeadwoodSoundConfig.getNormalWinSoundName(this._gameData!.currentWinRatioConfig!.type!);
        if(winSound && !this._belowStakeWinRestriction) { // #369
            SlotGame.sound.playEffect(winSound);
        }

        if(this._gameData!.isBigWin) {
            SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.BIG_WIN_INITIAL);
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(this._timeline) {
            if(this._timeline.isActive()) {
                this._timeline.pause();
                this._timeline.kill();
            }
            this._timeline = null;
        }
        while(this._winSymbols.length > 0) {
            const sym = this._winSymbols.pop()! as DeadwoodReelSymbol;
            sym.changeState({
                state : GameConfig.instance.SYMBOL_STATES.win,
                frames : [-1, -1]
            });
            if(sym.shouldPlayWinText && !sym.winTextPlayed) {
                this._gameView.playWinNumberOnPosition(sym.shouldPlayWinText.position, sym, sym.shouldPlayWinText.betWayWinData);
            }
        }
        this._doReelNudge.forEach((nudge:boolean, reelId:number) => {
            if(!nudge) {
                return;
            }

            const wildSymbol:DeadwoodStackedWild = <DeadwoodStackedWild>Reels.getSymbol(reelId, 0);
            wildSymbol.changeState({
                state : GameConfig.instance.SYMBOL_STATES.win,
                frames : [-1, -1]
            })
        });

        this._gameView.stopWinPresentation();
        this._waysWon.abort(isAborted, this._gameData!.isBigWin);
        this._winCountUp.abort(this._gameData!.singleWin, isAborted, this._gameData!.currentMultiplier, this._gameData!.isBigWin, this._belowStakeWinRestriction);
        if(isAborted && !this._gameData!.isBigWin) {
            SlotGame.winFieldController.showWinField();
        }
    }

    public resetFeature():void {
        this._winWaysWon = 0;
        this._bigWinLineSoundIndex = 0;
    }
}